












import { Component, Prop, Vue } from "vue-property-decorator";
import { PraesidiumQuestion } from "@/api/models/PraesidiumQuestion";
import { PraesidiumQuestionAnswer } from "@/api/models/PraesidiumQuestionAnswer";

@Component
export default class PraesidiumCardQuestionsAnswer extends Vue {
    /**
     * Question to display.
     */
    @Prop()
    question: PraesidiumQuestion;

    /**
     * Answer to display.
     */
    @Prop()
    answer: PraesidiumQuestionAnswer;
}
